<template>
  <div class="switchButton">
    <v-btn-toggle mandatory v-model="option" @change=updateVal() class=" buttonToggleStretch" dark>
        <v-btn depressed small block color="primary" >
            {{value1}}
        </v-btn>
        <v-btn depressed small block color="primary" >
            {{value2}}
        </v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
export default {
  name: "SwitchButton",
  props: {
   value1: String,
   value2: String
  },
  data() {
    return {
      option: 0,
    }
  },
  methods: {
    updateVal(){
      let result = this.option === 0 ? this.value1: this.value2;
      console.log(result);
      this.$emit('update',result);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .buttonToggleStretch {
        width:100%;
        margin:5px 0px;
    }
</style>
